import { type FC, type ReactElement } from 'react';
import EmptyIcon from '@/assets/svg/report-management.svg';

type Props = {
	onCreateMission?: () => void;
};

export const EmptyState: FC<Props> = ({ onCreateMission }: Props): ReactElement<Props> => {
	return (
		<div className="empty-state">
			<img
				className="illustration"
				src={EmptyIcon}
				alt=""
				loading="lazy"
			/>
			<h1 id="empty-title">Öğrencinize henüz hiç görev atamadınız!</h1>
			<p>Öğrencinizin kimlik keşfini akademik gelişimle birleştirmek ve sürece aktif katılımını sağlamak amacıyla, ona görevler atayabilirsiniz.</p>
			<div className="actions">
				<button
					onClick={onCreateMission}
					className="btn"
					type="button">
					<i className="icons-plus" />
					Yeni Görev
				</button>
			</div>
		</div>
	);
};
